<script>
import { muiLoader } from './config';

export default {
  name: 'MUILoader',

  props: muiLoader.props,

  computed: {

    /**
     * Calculate the loader radius.
     * @returns {Number} The radius in px.
     */
    radius() {
      return this.diameter / 2;
    },

    /**
     * Calculate the loader position in the canvas.
     * @returns {{x: number, y: number}} Object with loader coordinates.
     */
    position() {
      return {
        x: this.radius + this.border,
        y: this.radius + this.border,
      };
    },

    /**
     * Calculate the circle dashoffset with the percentage informed.
     * @returns {Number} The dashoffset value.
     */
    dashoffset() {
      return 100 - this.percentage;
    },

    /**
     * Generate size style of the svg tag.
     * @returns {String} The size style string.
     */
    sizeStyle() {
      return `width: ${this.diameter}px; height: ${this.diameter}px;`;
    },

    /**
     * Generate the viewbox of the svg tag.
     * @returns {String} The viewbox string.
     */
    viewbox() {
      const radiusPlusBorder = this.diameter + (this.border * 2);

      return `0 0 ${radiusPlusBorder} ${radiusPlusBorder}`;
    },
  },
};
</script>

<template>
  <div
    v-show="active"
    class="mui-loader inline-block"
    :class="{
      'mui-loader--spin': !paused,
      'mui-loader--paused': paused
    }"
  >
    <svg
      class="mui-loader__vector block"
      :viewBox="viewbox"
      :style="sizeStyle"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g>
        <circle
          :cx="position.x"
          :cy="position.y"
          :r="radius"
          fill="none"
          :stroke="backgroundColor"
          :stroke-width="border"
        />

        <circle
          :cx="position.x"
          :cy="position.y"
          :r="radius"
          fill="none"
          :stroke="borderColor"
          :stroke-width="border"
          stroke-linecap="round"
          pathLength="100"
          stroke-dasharray="100"
          :stroke-dashoffset="dashoffset"
        />
      </g>
    </svg>
  </div>
</template>

<style lang="stylus" scoped>
.mui-loader
	&--spin
		animation spin 1s linear infinite

	&--paused
		animation-play-state paused

	&__vector
		transform rotate(270deg)

	&__bar
		transition 0.25s ease-out
</style>
